// Duplicate review cards once for seamless marquee loop
(function(){
  const track = document.querySelector('.reviews-track');
  if (!track) return;
  const cards = Array.from(track.children);
  cards.forEach(c => track.appendChild(c.cloneNode(true)));
})();

// Floating nav: yellow + logo appears once user scrolls past the hero logo
// On pages without a .cover (PDP, etc.) → always show in scrolled state
(function(){
  const nav = document.getElementById('floatingNav');
  if (!nav) return;
  const cover = document.querySelector('.cover');
  if (!cover) {
    nav.classList.add('is-scrolled');
    return;
  }
  const threshold = () => Math.max(120, cover.offsetHeight * 0.6);
  let ticking = false;
  const update = () => {
    nav.classList.toggle('is-scrolled', window.scrollY > threshold());
    ticking = false;
  };
  window.addEventListener('scroll', () => {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
})();

// Language picker dropdown
(function(){
  const wrappers = document.querySelectorAll('.fnav-lang');
  if (!wrappers.length) return;
  wrappers.forEach(wrapper => {
    const trigger = wrapper.querySelector('[data-fnav-lang-trigger]');
    const list = wrapper.querySelector('[data-fnav-lang-list]');
    if (!trigger || !list) return;
    const close = () => {
      list.hidden = true;
      wrapper.removeAttribute('data-open');
      trigger.setAttribute('aria-expanded', 'false');
    };
    const open = () => {
      list.hidden = false;
      wrapper.setAttribute('data-open', '');
      trigger.setAttribute('aria-expanded', 'true');
    };
    trigger.addEventListener('click', e => {
      e.stopPropagation();
      list.hidden ? open() : close();
    });
    document.addEventListener('click', e => {
      if (!wrapper.contains(e.target)) close();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') close();
    });
  });
})();

// Cart quantity counter (page-level, simple +/- with form submit)
(function(){
  const lines = document.querySelectorAll('[data-cart-line]');
  if (!lines.length) return;
  lines.forEach(line => {
    const input = line.querySelector('[data-cart-qty]');
    const minus = line.querySelector('[data-cart-qty-minus]');
    const plus = line.querySelector('[data-cart-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', () => {
      const v = Math.max(0, parseInt(input.value || '0', 10) - 1);
      input.value = v;
      input.form && input.form.submit();
    });
    if (plus) plus.addEventListener('click', () => {
      input.value = parseInt(input.value || '0', 10) + 1;
      input.form && input.form.submit();
    });
    input.addEventListener('change', () => {
      input.form && input.form.submit();
    });
  });
})();

// Mobile menu toggle
(function(){
  const btn = document.getElementById('fnavMenuBtn');
  const panel = document.getElementById('fnavPanel');
  if (!btn || !panel) return;
  const setOpen = (open) => {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    panel.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  };
  btn.addEventListener('click', () => {
    setOpen(btn.getAttribute('aria-expanded') !== 'true');
  });
  panel.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => setOpen(false));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') setOpen(false);
  });
})();

// Smooth scroll for in-page anchor links (handles #x, /#x, /path#x on same page)
(function(){
  const easeOutQuart = t => 1 - Math.pow(1 - t, 4);
  const smoothScrollTo = (target) => {
    const nav = document.getElementById('floatingNav');
    const offset = nav ? nav.getBoundingClientRect().height + 16 : 16;
    const startY = window.scrollY;
    const targetY = target.getBoundingClientRect().top + startY - offset;
    const distance = targetY - startY;
    if (Math.abs(distance) < 4) return;
    const duration = Math.min(1100, Math.max(500, Math.abs(distance) * 0.6));
    const startTime = performance.now();
    const step = (now) => {
      const elapsed = now - startTime;
      const t = Math.min(1, elapsed / duration);
      window.scrollTo(0, startY + distance * easeOutQuart(t));
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href');
    if (!href) return;
    // Detect same-page anchor: starts with '#', or url matches current path + hash
    let hash = '';
    if (href.startsWith('#')) {
      hash = href;
    } else if (href.includes('#')) {
      try {
        const url = new URL(href, window.location.href);
        // Only handle same-page (same path + same origin)
        if (url.origin === window.location.origin && url.pathname === window.location.pathname && url.hash) {
          hash = url.hash;
        }
      } catch (_) { return; }
    }
    if (!hash || hash === '#' || hash.length < 2) return;
    const target = document.querySelector(hash);
    if (!target) return;
    e.preventDefault();
    smoothScrollTo(target);
    history.replaceState(null, '', hash);
  }, { capture: true });
})();

// Footer easter-egg reveal when user scrolls to bottom
(function(){
  const footer = document.querySelector('.footer');
  if (!footer) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) footer.classList.add('scrolled'); });
  }, { threshold: 0.5 });
  observer.observe(footer);
})();

// ─────────────────────────────────────────────────────────────────────────
// PDP: Variant Picker — Size icons + Pack cards
// Cascade-Update: pick size → filter packs available for that size → pick
// pack → swap image + price + variant-id + URL ?variant=X. No page-reload.
// ─────────────────────────────────────────────────────────────────────────
(function(){
  // Memoized money formatter — Intl.NumberFormat is expensive, instantiate once
  let _moneyFormatter = null;
  function getMoneyFormatter() {
    if (_moneyFormatter) return _moneyFormatter;
    try {
      _moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
      });
    } catch (e) { _moneyFormatter = null; }
    return _moneyFormatter;
  }
  function formatMoney(cents) {
    const f = getMoneyFormatter();
    if (f) return f.format(cents / 100);
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // Shopify image URL resize — produces ?width=N or _NNNx variant
  function shopifyResize(url, w) {
    if (!url) return url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
    if (/_\d+x\d*\.[a-z]+/i.test(url)) return url.replace(/_\d+x\d*\./i, '_' + w + 'x.');
    return url + (url.includes('?') ? '&' : '?') + 'width=' + w;
  }

  // Idle-time scheduler — fall back to setTimeout if requestIdleCallback unsupported
  const idleSchedule = (window.requestIdleCallback || function (fn) { return setTimeout(fn, 1); });

  class VariantPicker {
    constructor(section) {
      this.section = section;
      const jsonEl = section.querySelector('[data-product-json]');
      if (!jsonEl) return;
      try { this.product = JSON.parse(jsonEl.textContent); }
      catch (e) { console.error('[VariantPicker] product JSON parse failed', e); return; }

      this.form = section.querySelector('[data-product-form]');
      this.variantIdInput = section.querySelector('[data-variant-id]');
      this.imageEl = section.querySelector('[data-product-image]');
      const fallbackEl = section.querySelector('[data-size-fallback-images]');
      this.sizeFallbacks = {};
      if (fallbackEl) {
        try { this.sizeFallbacks = JSON.parse(fallbackEl.textContent); }
        catch (e) { /* ignore */ }
      }
      this.priceEl = section.querySelector('[data-product-price]');
      this.perPackEl = section.querySelector('[data-product-per-pack]');
      this.mmNumberEl = section.querySelector('[data-mm-number]');
      this.currentSizeLabelEl = section.querySelector('[data-current-size]');
      this.currentPackLabelEl = section.querySelector('[data-current-pack]');
      this.currentColorLabelEl = section.querySelector('[data-current-color]');
      this.colorWrapEl = section.querySelector('[data-color-wrap]');
      this.colorLabelEl = section.querySelector('[data-color-label]');
      this.hasColor = !!this.colorWrapEl;
      this.combosWithColors = this.hasColor
        ? (this.colorWrapEl.dataset.combosWithColors || '').split(',').map(s => s.trim()).filter(Boolean)
        : [];
      this.submitBtn = section.querySelector('.pdp-atc');
      this.submitText = section.querySelector('[data-atc-text]');
      // Mobile sticky ATC mirror
      this.stickyAtc = section.querySelector('[data-pdp-sticky-atc]');
      this.stickyBtn = section.querySelector('[data-sticky-atc-btn]');
      this.stickyText = section.querySelector('[data-sticky-atc-text]');
      this.stickyPrice = section.querySelector('[data-sticky-atc-price]');

      const activeSizeEl = section.querySelector('.pdp-size-icon[aria-checked="true"]');
      const activePackEl = section.querySelector('.pdp-pack-card[aria-checked="true"]');
      const activeColorEl = section.querySelector('.pdp-color-swatch[aria-checked="true"]');
      this.currentSize = activeSizeEl ? activeSizeEl.dataset.value : ((this.product.variants[0] || {}).option1);
      // Single-option products (e.g. card game "Versione") have no pack picker — seed currentPack
      // from the matching variant's option2 (usually undefined) so findCurrentVariant() resolves
      // on init instead of comparing against a hardcoded null.
      const initVariant = activePackEl
        ? null
        : (this.product.variants || []).find(v => v.option1 === this.currentSize);
      this.currentPack = activePackEl ? activePackEl.dataset.value : (initVariant ? initVariant.option2 : null);
      // Locale-safe default colour: the value most variants carry, derived from data rather
      // than a hardcoded English word — survives a catalog rename and IT/DE/EN translations.
      this.defaultColor = (function(variants){
        var counts = {}, best = null, bestN = 0;
        (variants || []).forEach(function(v){
          if (!v.option3) return;
          counts[v.option3] = (counts[v.option3] || 0) + 1;
          if (counts[v.option3] > bestN) { bestN = counts[v.option3]; best = v.option3; }
        });
        return best;
      })(this.product.variants);
      this.currentColor = this.hasColor
        ? (activeColorEl ? activeColorEl.dataset.value : this.defaultColor)
        : null;

      // Set initial body data-current-size for global --accent
      if (this.currentSize) document.body.dataset.currentSize = this.currentSize;

      this.bindEvents();
      this.bindKeyboard();
      this.bindGalleryThumbs();
      this.bindQtyCounter();
      this.syncFromUrl();
      // Always run a fresh refresh on init so per-filter prices and other
      // dynamic content are populated for ALL pack cards (not just the ones
      // Liquid pre-rendered for the default variant size).
      this.refresh();
      // Warm browser cache with every variant's image during idle time so
      // future switches hit the cache (instant display, no network wait).
      this.preloadVariantImages();
      // Hover-prefetch on size icons and color swatches — covers cases where
      // the idle preloader hasn't finished yet by the time user starts clicking.
      this.bindHoverPrefetch();
    }

    preloadVariantImages() {
      idleSchedule(() => {
        const seen = new Set();
        const widths = [480, 800, 1200]; // mirror the gallery img srcset breakpoints
        const queue = [];
        (this.product.variants || []).forEach(v => {
          const src = v.featured_image && v.featured_image.src;
          if (!src || seen.has(src)) return;
          seen.add(src);
          widths.forEach(w => queue.push(shopifyResize(src, w)));
        });
        // Also warm the per-size fallbacks (already cached for current size, but cheap)
        Object.values(this.sizeFallbacks || {}).forEach(url => { if (url) queue.push(url); });
        // Spread requests to avoid clobbering main-thread image decoding bursts
        let i = 0;
        const fire = () => {
          if (i >= queue.length) return;
          const img = new Image();
          img.fetchPriority = 'low';
          img.decoding = 'async';
          img.loading = 'eager';
          img.src = queue[i++];
          idleSchedule(fire);
        };
        fire();
      });
    }

    bindHoverPrefetch() {
      const variantBySize = (size) => (this.product.variants || []).find(v => v.option1 === size);
      const variantByColor = (color) => (this.product.variants || []).find(
        v => v.option1 === this.currentSize && v.option3 === color
      );
      const warm = (url) => {
        if (!url) return;
        const img = new Image(); img.decoding = 'async'; img.src = url;
      };
      this.section.querySelectorAll('.pdp-size-icon').forEach(btn => {
        const handler = () => {
          const v = variantBySize(btn.dataset.value);
          const s = v && v.featured_image && v.featured_image.src;
          if (s) { warm(s); warm(shopifyResize(s, 800)); }
        };
        btn.addEventListener('pointerenter', handler);
        btn.addEventListener('touchstart', handler, { passive: true });
      });
      this.section.querySelectorAll('.pdp-color-swatch').forEach(btn => {
        const handler = () => {
          const v = variantByColor(btn.dataset.value);
          const s = v && v.featured_image && v.featured_image.src;
          if (s) { warm(s); warm(shopifyResize(s, 800)); }
        };
        btn.addEventListener('pointerenter', handler);
        btn.addEventListener('touchstart', handler, { passive: true });
      });
    }

    bindEvents() {
      this.section.querySelectorAll('.pdp-size-icon').forEach(btn => {
        btn.addEventListener('click', () => this.selectSize(btn.dataset.value));
      });
      this.section.querySelectorAll('.pdp-pack-card').forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.hidden) return;
          this.selectPack(btn.dataset.value);
        });
      });
      this.section.querySelectorAll('.pdp-color-swatch').forEach(btn => {
        btn.addEventListener('click', () => this.selectColor(btn.dataset.value));
      });
    }

    bindKeyboard() {
      [['.pdp-size-picker', '.pdp-size-icon'], ['.pdp-pack-picker', '.pdp-pack-card'], ['.pdp-color-picker', '.pdp-color-swatch']].forEach(([groupSel, btnSel]) => {
        const group = this.section.querySelector(groupSel);
        if (!group) return;
        group.addEventListener('keydown', e => {
          if (!['ArrowRight','ArrowLeft','ArrowUp','ArrowDown'].includes(e.key)) return;
          const buttons = Array.from(group.querySelectorAll(btnSel)).filter(b => !b.hidden);
          const idx = buttons.indexOf(document.activeElement);
          if (idx === -1) return;
          e.preventDefault();
          const next = (e.key === 'ArrowRight' || e.key === 'ArrowDown')
            ? buttons[(idx + 1) % buttons.length]
            : buttons[(idx - 1 + buttons.length) % buttons.length];
          next.focus();
          next.click();
        });
      });
    }

    bindGalleryThumbs() {
      this.section.querySelectorAll('.pdp-gal-thumb').forEach(thumb => {
        thumb.addEventListener('click', () => {
          const src = thumb.dataset.thumbSrc;
          if (src && this.imageEl) {
            // refresh() sets a srcset which would override a bare src swap —
            // clear it or the thumbnail click changes nothing visually.
            this.imageEl.removeAttribute('srcset');
            this.imageEl.removeAttribute('sizes');
            this.imageEl.src = src;
          }
          this.section.querySelectorAll('.pdp-gal-thumb').forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
        });
      });
    }

    bindQtyCounter() {
      const input = this.section.querySelector('[data-qty-input]');
      const minus = this.section.querySelector('[data-qty-minus]');
      const plus = this.section.querySelector('[data-qty-plus]');
      if (!input) return;
      if (minus) minus.addEventListener('click', () => {
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      });
      if (plus) plus.addEventListener('click', () => {
        input.value = parseInt(input.value || '1', 10) + 1;
      });
    }

    syncFromUrl() {
      const url = new URL(window.location);
      const variantParam = url.searchParams.get('variant');
      const sizeParam = url.searchParams.get('size');

      if (variantParam) {
        const variant = this.product.variants.find(v => String(v.id) === String(variantParam));
        if (variant) {
          this.currentSize = variant.option1;
          this.currentPack = variant.option2;
          if (this.hasColor) this.currentColor = variant.option3 || this.defaultColor;
          this.refresh();
          return;
        }
      }

      if (sizeParam) {
        const variantForSize = this.product.variants.find(v => v.option1 === sizeParam);
        if (variantForSize) {
          this.currentSize = variantForSize.option1;
          this.currentPack = variantForSize.option2;
          if (this.hasColor) this.currentColor = variantForSize.option3 || this.defaultColor;
          this.refresh();
        }
      }
    }

    selectSize(size) {
      this.currentSize = size;
      // Pick first available pack for this size if current pack isn't available
      const validVariants = this.product.variants.filter(v => v.option1 === size);
      if (!validVariants.length) return;
      const stillValid = validVariants.find(v => v.option2 === this.currentPack);
      if (!stillValid) this.currentPack = validVariants[0].option2;
      // Color — keep if still valid for new size, else fall back to the default colour
      if (this.hasColor) {
        const stillValidColor = validVariants.find(v => v.option3 === this.currentColor);
        if (!stillValidColor) {
          const std = validVariants.find(v => v.option3 === this.defaultColor);
          this.currentColor = std ? std.option3 : (validVariants[0].option3 || this.defaultColor);
        }
      }
      this.refresh();
    }

    selectPack(pack) {
      this.currentPack = pack;
      // Colour may not exist for this size+pack. Prefer the current one, then Standard/Classic,
      // then whatever genuinely exists (6mm|100 is SUMMER EDITION only) — never a dead combo.
      if (this.hasColor) {
        const variantsForSizePack = this.product.variants.filter(v =>
          v.option1 === this.currentSize && v.option2 === pack);
        const exists = variantsForSizePack.find(v => v.option3 === this.currentColor);
        if (!exists && variantsForSizePack.length) {
          const std = variantsForSizePack.find(v => v.option3 === this.defaultColor);
          this.currentColor = std ? std.option3 : (variantsForSizePack[0].option3 || this.defaultColor);
        }
      }
      this.refresh();
    }

    selectColor(color) {
      this.currentColor = color;
      // If current pack doesn't have this color, jump to a pack that does
      const variantsForSizeColor = this.product.variants.filter(v =>
        v.option1 === this.currentSize && v.option3 === color);
      if (variantsForSizeColor.length) {
        const stillValidPack = variantsForSizeColor.find(v => v.option2 === this.currentPack);
        if (!stillValidPack) this.currentPack = variantsForSizeColor[0].option2;
      }
      this.refresh();
    }

    findCurrentVariant() {
      return this.product.variants.find(v => {
        if (v.option1 !== this.currentSize) return false;
        if (v.option2 !== this.currentPack) return false;
        if (this.hasColor && v.option3 !== this.currentColor) return false;
        return true;
      });
    }

    refresh() {
      const variant = this.findCurrentVariant();
      if (!variant) return;

      // Image — variant featured image, or bundled per-size fallback.
      // Images are pre-warmed during idle time + on hover (see preloadVariantImages /
      // bindHoverPrefetch) so the swap is usually a browser-cache hit → instant display.
      if (this.imageEl) {
        const updateImg = (src) => {
          if (!src || this.imageEl.dataset.lastSrc === src) return;
          this.imageEl.dataset.lastSrc = src;
          // Atomic swap — set src + srcset + sizes in the same task, no rAF dance:
          // when image is preloaded the browser uses the cached bytes immediately.
          this.imageEl.src = src;
          this.imageEl.srcset = shopifyResize(src, 480) + ' 480w, ' +
                                shopifyResize(src, 800) + ' 800w, ' +
                                shopifyResize(src, 1200) + ' 1200w';
          this.imageEl.sizes = '(max-width: 540px) 92vw, (max-width: 960px) 80vw, 55vw';
        };
        if (variant.featured_image && variant.featured_image.src) {
          updateImg(variant.featured_image.src);
        } else if (this.sizeFallbacks[this.currentSize]) {
          updateImg(this.sizeFallbacks[this.currentSize]);
        }
        // Reset thumb active
        const firstThumb = this.section.querySelector('.pdp-gal-thumb');
        if (firstThumb) {
          this.section.querySelectorAll('.pdp-gal-thumb').forEach(t => t.classList.remove('active'));
          firstThumb.classList.add('active');
        }
      }

      // Price
      if (this.priceEl) this.priceEl.textContent = formatMoney(variant.price);
      if (this.perPackEl) this.perPackEl.textContent = '/ ' + (this.perPackEl.getAttribute('data-per-pack-label') || '') + ' ' + (variant.option2 || '');

      // mm-badge
      if (this.mmNumberEl) {
        const num = String(variant.option1 || '').replace(/mm/i, '').trim();
        this.mmNumberEl.textContent = num;
      }

      // Variant ID
      if (this.variantIdInput) this.variantIdInput.value = variant.id;

      // Update root data-current-size so CSS --accent variable kicks in
      this.section.dataset.currentSize = this.currentSize;
      document.body.dataset.currentSize = this.currentSize;

      // URL
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      // Size active states
      this.section.querySelectorAll('.pdp-size-icon').forEach(b => {
        const active = b.dataset.value === this.currentSize;
        b.setAttribute('aria-checked', active ? 'true' : 'false');
        b.classList.toggle('is-active', active);
      });

      // Volume-saving base: smallest pack's per-filter price for the CURRENT size
      let _baseVar = null, _basePackInt = 0;
      this.section.querySelectorAll('.pdp-pack-card').forEach(b => {
        const pv = b.dataset.value;
        const pInt = parseInt(pv.replace(/[^0-9]/g, ''), 10);
        const v = this.product.variants.find(x => x.option1 === this.currentSize && x.option2 === pv);
        if (v && pInt > 0 && (_basePackInt === 0 || pInt < _basePackInt)) { _baseVar = v; _basePackInt = pInt; }
      });
      const _basePpf = (_baseVar && _basePackInt > 0) ? (_baseVar.price / _basePackInt) : 0;

      // Pack active states + hide unavailable for current size + update per-filter price + savings badge
      this.section.querySelectorAll('.pdp-pack-card').forEach(b => {
        const packValue = b.dataset.value;
        const variantForPack = this.product.variants.find(v => v.option1 === this.currentSize && v.option2 === packValue);
        const availForSize = !!variantForPack;
        b.hidden = !availForSize;
        b.classList.toggle('is-hidden', !availForSize);
        if (!availForSize) return;
        const isActive = packValue === this.currentPack;
        b.setAttribute('aria-checked', isActive ? 'true' : 'false');
        b.classList.toggle('is-active', isActive);
        b.dataset.variantId = variantForPack.id;
        // Special-Edition-Pack (z.B. SUMMER EDITION im Glas): Badge auf der Pill pflegen.
        // Datengetrieben ueber option3 der aufloesenden Variante — kein hartkodiertes Pack.
        const _specialName = String(variantForPack.option3 || '');
        const _isSpecial = _specialName.toLowerCase() === 'summer edition';
        let _specEl = b.querySelector('.pack-special');
        if (_isSpecial) {
          if (!_specEl) {
            _specEl = document.createElement('span');
            _specEl.className = 'pack-special';
            b.appendChild(_specEl);
          }
          _specEl.textContent = _specialName;
          _specEl.hidden = false;
        } else if (_specEl) {
          _specEl.hidden = true;
        }
        // Update pack price + per-filter
        const priceEl = b.querySelector('[data-pack-price]');
        if (priceEl) priceEl.textContent = formatMoney(variantForPack.price);
        const packInt = parseInt(packValue.replace(/[^0-9]/g, ''), 10);
        if (packInt > 0) {
          const perFilterEl = b.querySelector('[data-per-filter]');
          if (perFilterEl) perFilterEl.textContent = formatMoney(Math.round(variantForPack.price / packInt)) + ' / filter';
        }
        // Volume-saving badge vs base pack (recomputed per size, independent of compare_at_price)
        let saveEl = b.querySelector('.save');
        const ppf = packInt > 0 ? (variantForPack.price / packInt) : 0;
        const sav = (_basePpf > 0 && ppf > 0) ? Math.round((1 - ppf / _basePpf) * 100) : 0;
        if (sav > 0) {
          if (!saveEl) { saveEl = document.createElement('span'); saveEl.className = 'save'; b.appendChild(saveEl); }
          saveEl.textContent = '\u2212' + sav + '%';
          saveEl.hidden = false;
        } else if (saveEl) {
          saveEl.remove();
        }
      });

      // Color picker — visibility + swatch states (only when this size+pack combo has color variants)
      if (this.hasColor) {
        const currentCombo = this.currentSize + '|' + this.currentPack;
        const showColors = this.combosWithColors.indexOf(currentCombo) !== -1;
        this.colorWrapEl.classList.toggle('is-hidden', !showColors);
        if (this.colorLabelEl) this.colorLabelEl.classList.toggle('is-hidden', !showColors);
        this.section.querySelectorAll('.pdp-color-swatch').forEach(b => {
          const active = b.dataset.value === this.currentColor;
          b.setAttribute('aria-checked', active ? 'true' : 'false');
          b.classList.toggle('is-active', active);
        });
      }

      // Labels
      if (this.currentSizeLabelEl) this.currentSizeLabelEl.textContent = this.currentSize;
      if (this.currentPackLabelEl) this.currentPackLabelEl.textContent = this.currentPack;
      if (this.currentColorLabelEl) this.currentColorLabelEl.textContent = this.currentColor || this.defaultColor || '';

      // Per-size marketing copy (Smart-Filter PDP only) — swap tagline + body on size change.
      // Data block #pdp-size-copy is rendered by main-product.liquid only for the smart-filter PDP,
      // so this is a no-op on every other product.
      const pitchCopyEl = this.section.querySelector('#pdp-size-copy');
      if (pitchCopyEl) {
        if (!this._sizeCopy) {
          try { this._sizeCopy = JSON.parse(pitchCopyEl.textContent); }
          catch (e) { this._sizeCopy = {}; }
        }
        const copyEntry = this._sizeCopy[this.currentSize];
        if (copyEntry) {
          const tagEl = this.section.querySelector('.pdp-pitch-tagline');
          if (tagEl) {
            if (copyEntry.tagline) {
              const strong = document.createElement('strong');
              strong.textContent = copyEntry.tagline;
              tagEl.textContent = '';
              tagEl.appendChild(strong);
              tagEl.hidden = false;
            } else {
              tagEl.hidden = true;
            }
          }
          const bodyEl = this.section.querySelector('.pdp-pitch-body');
          if (bodyEl && copyEntry.body != null) bodyEl.innerHTML = copyEntry.body;
        }
      }

      // Add-to-Cart state
      if (this.submitBtn && this.submitText) {
        if (variant.available) {
          this.submitBtn.disabled = false;
          this.submitText.textContent = this.submitBtn.dataset.defaultLabel || 'Add to Cart';
        } else {
          this.submitBtn.disabled = true;
          this.submitText.textContent = this.submitBtn.dataset.soldOutLabel || 'Sold out';
        }
      }
      // Mirror state to sticky mobile ATC
      if (this.stickyBtn) {
        const stickyLabel = variant.available
          ? (this.stickyBtn.dataset.defaultLabel || 'Add to Cart')
          : (this.stickyBtn.dataset.soldOutLabel || 'Sold out');
        this.stickyBtn.disabled = !variant.available;
        if (this.stickyText) this.stickyText.textContent = stickyLabel;
        if (this.stickyPrice) this.stickyPrice.textContent = formatMoney(variant.price);
      }
    }
  }

  document.querySelectorAll('section.pdp[data-section-id]').forEach(section => {
    try { new VariantPicker(section); }
    catch (e) { console.error('[VariantPicker] init failed; cart-drawer will still bootstrap', e); }
  });

  // ─────────────────────────────────────────────────────────────────────────
  // CartDrawer — Slide-in cart, all AJAX, no page reloads
  // ─────────────────────────────────────────────────────────────────────────
  const escapeHtml = (str) => String(str == null ? '' : str)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

  function debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), wait);
    };
  }

  function t(key, fallback) {
    // i18n with fallback. Shopify renders {{ 'cart.foo' | t }} server-side into Liquid;
    // here we just use whatever text is already on the page or fall back.
    return fallback;
  }

  const FETCH_JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  class CartDrawer {
    constructor(drawerEl) {
      this.drawer = drawerEl;
      this.scrim = document.querySelector('[data-cart-scrim]');
      // If page has no nav cart trigger (e.g. policies.liquid where sections
      // render unreliably), inject a floating fallback button so the drawer is
      // still openable from every page.
      if (!document.querySelector('[data-cart-trigger]')) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cart-floating-trigger';
        btn.setAttribute('data-cart-trigger', '');
        btn.setAttribute('aria-label', 'Open cart');
        btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h2l2.5 13a2 2 0 0 0 2 1.6h8.5a2 2 0 0 0 2-1.6L22 6H6"/><circle cx="9" cy="21" r="1.5"/><circle cx="19" cy="21" r="1.5"/></svg><span class="fnav-count" data-cart-count></span>';
        document.body.appendChild(btn);
      }
      this.itemsContainer = drawerEl.querySelector('[data-cart-items]');
      this.emptyEl = drawerEl.querySelector('[data-cart-empty]');
      this.footEl = drawerEl.querySelector('[data-cart-foot]');
      this.subtotalEl = drawerEl.querySelector('[data-cart-subtotal]');
      this.checkoutAmountEl = drawerEl.querySelector('[data-cart-checkout-amount]');
      this.headCountEl = drawerEl.querySelector('[data-cart-count]');
      this.badgeEls = Array.from(document.querySelectorAll('[data-cart-count]'));
      this.shippingBar = drawerEl.querySelector('[data-shipping-bar]');
      this.shippingLabel = drawerEl.querySelector('[data-shipping-label]');
      this.shippingFill = drawerEl.querySelector('[data-shipping-fill]');
      this.noteEl = drawerEl.querySelector('[data-cart-note]');
      this.discountForm = drawerEl.querySelector('[data-cart-discount-form]');
      this.discountInput = drawerEl.querySelector('[data-cart-discount-input]');
      this.discountMsg = drawerEl.querySelector('[data-cart-discount-msg]');
      this.discountList = drawerEl.querySelector('[data-cart-discount-list]');
      this.crosssellRoot = drawerEl.querySelector('[data-cart-crosssell]');
      const _thresholdEl = drawerEl.querySelector('[data-shipping-threshold]');
      this.shippingThreshold = (_thresholdEl && parseInt(_thresholdEl.dataset.shippingThreshold, 10)) || 7500;
      this.shippingAvailable = !_thresholdEl || _thresholdEl.dataset.shippingAvailable !== '0';

      // Hydrate from Liquid-rendered JSON — no startup fetch
      this.cart = { item_count: 0, items: [], total_price: 0 };
      const initEl = drawerEl.querySelector('[data-cart-initial]');
      if (initEl) {
        try { this.cart = JSON.parse(initEl.textContent); }
        catch (e) { console.warn('[CartDrawer] hydrate failed', e); }
      }

      this._lastFocus = null;
      this._busyKeys = new Set();
      this._synced = false;
      this._prevCount = this.cart.item_count;

      this.bindEvents();
      this.renderShippingBar();
    }

    // ── Network helpers — use Section Rendering API where possible to avoid double-fetches ──
    async _postJSON(url, body) {
      const r = await fetch(url, { method: 'POST', headers: FETCH_JSON_HEADERS, body: JSON.stringify(body) });
      const json = await r.json().catch(() => ({}));
      if (!r.ok) throw Object.assign(new Error(json.description || r.statusText), { status: r.status, body: json });
      return json;
    }

    async _getCart() {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
      return r.json();
    }

    // ── Public mutations ──
    async addItem(variantId, qty) {
      try {
        // /cart/add.js returns the LINE ITEM (not full cart); follow with /cart.js for totals
        await this._postJSON('/cart/add.js', { id: variantId, quantity: qty || 1 });
        this.cart = await this._getCart();
        this.render({ mark: variantId });
        this.open();
      } catch (e) {
        console.warn('[CartDrawer] addItem failed', e);
        this.flashError(e.message || 'Could not add to cart');
      }
    }

    async updateLine(key, qty) {
      // Optimistic UI — update DOM immediately, then reconcile with server
      const idx = (this.cart.items || []).findIndex(i => i.key === key);
      if (idx === -1) return;
      const row = this.itemsContainer.querySelector('[data-line-key="' + cssEscape(key) + '"]');
      if (qty === 0 && row) {
        row.classList.add('is-leaving');
      } else if (row) {
        row.classList.add('is-busy');
        const qtyEl = row.querySelector('[data-qty-value]');
        if (qtyEl) qtyEl.textContent = String(qty);
      }
      this._busyKeys.add(key);
      try {
        this.cart = await this._postJSON('/cart/change.js', { id: key, quantity: qty });
      } catch (e) {
        console.warn('[CartDrawer] updateLine failed', e);
        // revert: fall back to server state
        this.cart = await this._getCart();
      } finally {
        this._busyKeys.delete(key);
        // Wait for leave animation before final re-render
        if (qty === 0) {
          setTimeout(() => this.render(), 220);
        } else {
          this.render();
        }
      }
    }

    async updateNote(text) {
      try {
        await this._postJSON('/cart/update.js', { note: text });
      } catch (e) { console.warn('[CartDrawer] updateNote', e); }
    }

    async applyDiscount(code) {
      if (!code) return;
      this.discountMsg.hidden = true;
      this.discountMsg.classList.remove('is-ok');
      try {
        // Shopify discount endpoint sets a cookie; we just need the side-effect
        await fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'follow' });
        this.cart = await this._getCart();
        const applied = (this.cart.cart_level_discount_applications || []).some(
          d => d.title && d.title.toUpperCase() === code.toUpperCase()
        );
        if (applied) {
          this.discountMsg.textContent = '✓ Applied';
          this.discountMsg.classList.add('is-ok');
        } else {
          this.discountMsg.textContent = (this.discountInput && this.discountInput.dataset.errorMsg) || 'Code invalid';
        }
        this.discountMsg.hidden = false;
        this.render();
      } catch (e) {
        console.warn('[CartDrawer] applyDiscount', e);
        this.discountMsg.textContent = 'Network error';
        this.discountMsg.hidden = false;
      }
    }

    // ── Lazy background-sync — first open from non-pristine state ──
    async _backgroundSync() {
      if (this._synced) return;
      this._synced = true;
      try {
        const fresh = await this._getCart();
        if (fresh.item_count !== this.cart.item_count || fresh.total_price !== this.cart.total_price) {
          this.cart = fresh;
          this.render();
        }
      } catch (_) {}
    }

    // ── Rendering ──
    render(opts) {
      opts = opts || {};
      const count = this.cart.item_count || 0;

      // badge across page (with pulse if value changed)
      const changed = count !== this._prevCount;
      this._prevCount = count;
      for (let i = 0; i < this.badgeEls.length; i++) {
        const b = this.badgeEls[i];
        b.textContent = String(count);
        if (changed) {
          b.classList.remove('pulse');
          // force reflow so animation restarts
          void b.offsetWidth;
          b.classList.add('pulse');
        }
      }

      // empty vs filled
      const isEmpty = count === 0;
      if (this.emptyEl) this.emptyEl.hidden = !isEmpty;
      if (this.footEl) this.footEl.hidden = isEmpty;
      if (isEmpty) {
        this.itemsContainer.innerHTML = '';
        if (this.shippingBar) this.shippingBar.hidden = true;
        return;
      }

      // items list — efficient diff if possible, else full re-render
      this.renderItems(opts.mark);
      this.renderShippingBar();

      // money displays
      const subtotal = formatMoney(this.cart.total_price || 0);
      if (this.subtotalEl) this.subtotalEl.textContent = subtotal;
      if (this.checkoutAmountEl) this.checkoutAmountEl.textContent = subtotal;

      // sync note (avoid clobbering during typing)
      if (this.noteEl && document.activeElement !== this.noteEl) {
        this.noteEl.value = this.cart.note || '';
      }

      this.renderDiscounts();
    }

    renderItems(markVariantId) {
      const items = this.cart.items || [];
      // Build fragment off-DOM, swap in one shot
      const frag = document.createDocumentFragment();
      const wrap = document.createElement('div');
      const html = items.map(item => {
        const imgUrl = item.image ? item.image.replace(/(\.[^.\/]+)$/, '_220x$1') : '';
        const img = imgUrl
          ? '<img src="' + esc(imgUrl) + '" alt="' + esc(item.product_title) + '" width="80" height="80" loading="lazy">'
          : '';
        const variantText = item.variant_title && item.variant_title !== 'Default Title'
          ? '<div class="cart-item-variant">' + esc(item.variant_title.replace(/ \/ /g, ' · ')) + '</div>'
          : '';
        const isFresh = markVariantId && Number(item.variant_id) === Number(markVariantId) ? ' is-fresh' : '';
        return (
          '<article class="cart-item' + isFresh + '" data-cart-item data-line-key="' + esc(item.key) + '">' +
            '<a href="' + esc(item.url) + '" class="cart-item-img" data-cart-close tabindex="-1">' + img + '</a>' +
            '<div class="cart-item-body">' +
              '<a href="' + esc(item.url) + '" class="cart-item-title" data-cart-close>' + esc(item.product_title) + '</a>' +
              variantText +
              '<div class="cart-item-row">' +
                '<div class="cart-qty">' +
                  '<button type="button" class="cart-qty-btn" data-qty-decrease aria-label="Decrease quantity">−</button>' +
                  '<span class="cart-qty-value" data-qty-value>' + item.quantity + '</span>' +
                  '<button type="button" class="cart-qty-btn" data-qty-increase aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<div class="cart-item-price" data-line-price>' + formatMoney(item.final_line_price) + '</div>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="cart-item-remove" data-cart-remove aria-label="Remove">' +
              '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">' +
                '<line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/>' +
              '</svg>' +
            '</button>' +
          '</article>'
        );
      }).join('');
      wrap.innerHTML = html;
      while (wrap.firstChild) frag.appendChild(wrap.firstChild);
      this.itemsContainer.replaceChildren(frag);
    }

    renderShippingBar() {
      if (!this.shippingBar) return;
      if (!this.shippingAvailable) { this.shippingBar.hidden = true; return; }
      const count = this.cart.item_count || 0;
      if (count === 0) { this.shippingBar.hidden = true; return; }
      this.shippingBar.hidden = false;
      const total = this.cart.total_price || 0;
      const threshold = this.shippingThreshold;
      if (total >= threshold) {
        this.shippingBar.classList.add('is-unlocked');
        if (this.shippingLabel) {
          this.shippingLabel.textContent = '✓ ' + (this.shippingLabel.dataset.unlocked || 'Free shipping unlocked');
        }
        if (this.shippingFill) this.shippingFill.style.transform = 'scaleX(1)';
      } else {
        this.shippingBar.classList.remove('is-unlocked');
        const remaining = threshold - total;
        const ratio = Math.max(0.04, Math.min(1, total / threshold));
        if (this.shippingLabel) {
          const tmpl = this.shippingLabel.dataset.need || '{amount} to free shipping';
          this.shippingLabel.textContent = tmpl.replace('{amount}', formatMoney(remaining));
        }
        if (this.shippingFill) this.shippingFill.style.transform = 'scaleX(' + ratio.toFixed(3) + ')';
      }
    }

    renderDiscounts() {
      if (!this.discountList) return;
      const apps = (this.cart && this.cart.cart_level_discount_applications) || [];
      if (!apps.length) { this.discountList.innerHTML = ''; return; }
      this.discountList.innerHTML = apps.map(d =>
        '<div class="cart-discount-chip"><span>' + esc(d.title) + '</span>' +
        '<span class="cart-discount-amount">−' + formatMoney(d.total_allocated_amount) + '</span></div>'
      ).join('');
    }

    flashError(msg) {
      const head = this.drawer.querySelector('.cart-drawer-head');
      if (!head) return;
      const old = head.querySelector('.cart-flash');
      if (old) old.remove();
      const div = document.createElement('div');
      div.className = 'cart-flash';
      div.textContent = msg;
      div.style.cssText = 'position:absolute;left:0;right:0;top:100%;padding:8px 16px;background:#d94646;color:#fff;font-family:var(--mono);font-size:12px;z-index:3;';
      head.style.position = 'relative';
      head.appendChild(div);
      setTimeout(() => div.remove(), 3500);
    }

    // ── Open/Close + focus management ──
    open() {
      if (this.drawer.classList.contains('is-open')) return;
      this._lastFocus = document.activeElement;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      if (this.scrim) {
        this.scrim.classList.add('is-open');
        this.scrim.setAttribute('aria-hidden', 'false');
      }
      document.body.style.overflow = 'hidden';
      // Background-sync on first open (covers stale state after another tab modified the cart)
      this._backgroundSync();
      // Focus the close button so keyboard users land somewhere actionable
      requestAnimationFrame(() => {
        const closeBtn = this.drawer.querySelector('[data-cart-close]');
        if (closeBtn) closeBtn.focus();
      });
    }

    close() {
      if (!this.drawer.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.scrim) {
        this.scrim.classList.remove('is-open');
        this.scrim.setAttribute('aria-hidden', 'true');
      }
      document.body.style.overflow = '';
      if (this._lastFocus && typeof this._lastFocus.focus === 'function') {
        try { this._lastFocus.focus(); } catch (_) {}
      }
    }

    _trapFocus(e) {
      if (!this.drawer.classList.contains('is-open') || e.key !== 'Tab') return;
      const sel = 'a[href]:not([tabindex="-1"]),button:not([disabled]):not([tabindex="-1"]),input:not([disabled]):not([tabindex="-1"]),textarea:not([disabled]):not([tabindex="-1"]),summary:not([tabindex="-1"])';
      const nodes = Array.from(this.drawer.querySelectorAll(sel)).filter(n => n.offsetParent !== null);
      if (!nodes.length) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }

    bindEvents() {
      // Cart triggers — delegation handles dynamically inserted buttons too
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-cart-trigger]');
        if (trigger) { e.preventDefault(); this.open(); return; }
        const closer = e.target.closest('[data-cart-close]');
        if (closer && this.drawer.contains(closer)) { e.preventDefault(); this.close(); return; }
      });

      // Prefetch cart on hover/touchstart of cart trigger (uses idle time)
      const prefetch = () => { if (!this._synced) this._backgroundSync(); };
      document.addEventListener('pointerenter', (e) => {
        if (e.target.closest && e.target.closest('[data-cart-trigger]')) prefetch();
      }, true);

      // Scrim click
      if (this.scrim) this.scrim.addEventListener('click', () => this.close());

      // Escape + focus trap
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) { this.close(); return; }
        this._trapFocus(e);
      });

      // Line-item +/- and remove (event delegation, scoped to items list)
      if (this.itemsContainer) {
        this.itemsContainer.addEventListener('click', (e) => {
          const item = e.target.closest('[data-cart-item]');
          if (!item) return;
          const key = item.dataset.lineKey;
          if (this._busyKeys.has(key)) return;
          if (e.target.closest('[data-cart-remove]')) { this.updateLine(key, 0); return; }
          if (e.target.closest('[data-qty-increase]')) {
            const cur = this.cart.items.find(i => i.key === key);
            if (cur) this.updateLine(key, cur.quantity + 1);
            return;
          }
          if (e.target.closest('[data-qty-decrease]')) {
            const cur = this.cart.items.find(i => i.key === key);
            if (cur) this.updateLine(key, Math.max(0, cur.quantity - 1));
            return;
          }
        });
      }

      // Notes — debounced save
      if (this.noteEl) {
        this.noteEl.addEventListener('input', debounce(() => this.updateNote(this.noteEl.value), 550));
      }

      // Discount form
      if (this.discountForm) {
        this.discountForm.addEventListener('submit', (e) => {
          e.preventDefault();
          const code = (this.discountInput.value || '').trim();
          if (code) this.applyDiscount(code);
        });
      }

      // Cross-sell
      if (this.crosssellRoot) {
        this.crosssellRoot.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-cs-add]');
          if (!btn) return;
          e.preventDefault();
          const vid = btn.dataset.variantId;
          if (!vid) return;
          btn.disabled = true;
          this.addItem(vid, 1).finally(() => { btn.disabled = false; });
        });
      }

      // Swipe-to-close on mobile (right-swipe ≥ 32% of drawer width)
      let touchStartX = 0, touchCurrentX = 0, dragging = false;
      this.drawer.addEventListener('touchstart', (e) => {
        if (!this.drawer.classList.contains('is-open')) return;
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchCurrentX = touchStartX;
        dragging = true;
      }, { passive: true });
      this.drawer.addEventListener('touchmove', (e) => {
        if (!dragging) return;
        touchCurrentX = e.touches[0].clientX;
        const delta = Math.max(0, touchCurrentX - touchStartX);
        if (delta > 6) {
          this.drawer.style.setProperty('--drag', delta + 'px');
          this.drawer.classList.add('is-dragging');
        }
      }, { passive: true });
      const endTouch = () => {
        if (!dragging) return;
        dragging = false;
        const delta = touchCurrentX - touchStartX;
        this.drawer.classList.remove('is-dragging');
        this.drawer.style.removeProperty('--drag');
        if (delta > this.drawer.offsetWidth * 0.32) this.close();
      };
      this.drawer.addEventListener('touchend', endTouch, { passive: true });
      this.drawer.addEventListener('touchcancel', endTouch, { passive: true });
    }
  }

  // Tiny helpers used by CartDrawer
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function cssEscape(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/[^a-zA-Z0-9_-]/g, c => '\\' + c);
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Bootstrap — singleton + ATC intercept
  // ─────────────────────────────────────────────────────────────────────────
  function bootstrapCartDrawer() {
    try {
      const drawerEl = document.querySelector('[data-cart-drawer]');
      if (!drawerEl) return;
      window.WeedlezCart = new CartDrawer(drawerEl);
      // Intercept every PDP add-to-cart form
      document.addEventListener('submit', (e) => {
        const form = e.target.closest('form[data-product-form]');
        if (!form || !window.WeedlezCart) return;
        e.preventDefault();
        const idInput = form.querySelector('[name="id"]');
        const qtyInput = form.querySelector('[name="quantity"]');
        if (!idInput) return;
        const qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        window.WeedlezCart.addItem(idInput.value, qty);
      });
      // Direct visits to /cart redirect to /#cart — auto-open the drawer
      if (window.location.hash === '#cart') {
        history.replaceState(null, '', window.location.pathname + window.location.search);
        Promise.resolve().then(() => window.WeedlezCart.open());
      }
    } catch (e) {
      console.error('[CartDrawer] bootstrap failed; falling back to /cart redirect on icon click', e);
      // Safety net: if drawer init crashed but the trigger button exists, at least navigate.
      document.addEventListener('click', (ev) => {
        const t = ev.target.closest('[data-cart-trigger]');
        if (t) { ev.preventDefault(); window.location.href = '/cart'; }
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrapCartDrawer);
  } else {
    bootstrapCartDrawer();
  }

})();

// ─────────────────────────────────────────────────────────────────────────
// Mobile Sticky ATC — show on scroll past main ATC, click forwards to form
// ─────────────────────────────────────────────────────────────────────────
(function(){
  const stickyEl = document.querySelector('[data-pdp-sticky-atc]');
  if (!stickyEl) return;
  const section = stickyEl.closest('section.pdp');
  if (!section) return;
  const mainAtc = section.querySelector('.pdp-atc:not(.pdp-sticky-atc-btn)');
  const form = section.querySelector('[data-product-form]');
  const stickyBtn = stickyEl.querySelector('[data-sticky-atc-btn]');
  if (!stickyBtn || !form) return;

  document.body.classList.add('has-sticky-atc');

  // Click on sticky → submit the main form (intercepted by CartDrawer)
  stickyBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (stickyBtn.disabled) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  });

  // Show sticky only after user scrolls past the main ATC. IntersectionObserver:
  // when main ATC enters viewport → hide sticky. When it exits → show sticky.
  if (mainAtc && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // is-visible = main ATC is NOT visible
        stickyEl.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '-72px 0px 0px 0px', threshold: 0 });
    io.observe(mainAtc);
  } else {
    // Fallback: always show
    stickyEl.classList.add('is-visible');
  }
})();

// ─────────────────────────────────────────────────────────────────────────
// BoH Sticky Buy Bar — show on scroll past #boh-buy, smooth-scroll back on click
// ─────────────────────────────────────────────────────────────────────────
(function(){
  const stickyEl = document.querySelector('[data-boh-sticky-buy]');
  if (!stickyEl) return;
  const buySection = document.getElementById('boh-buy');
  if (!buySection) return;

  document.body.classList.add('has-boh-sticky');

  // Show sticky bar when #boh-buy section scrolls out of viewport
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      stickyEl.classList.toggle('is-visible', !entry.isIntersecting);
    }, { rootMargin: '-72px 0px 0px 0px', threshold: 0 });
    io.observe(buySection);
  } else {
    // Fallback: always visible
    stickyEl.classList.add('is-visible');
  }

  // Click sticky CTA → smooth-scroll back to the buy section
  const ctaBtn = stickyEl.querySelector('[data-boh-sticky-cta]');
  if (ctaBtn) {
    ctaBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const nav = document.getElementById('floatingNav');
      const offset = nav ? nav.getBoundingClientRect().height + 16 : 16;
      const top = buySection.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  }
})();
